import updateReduxAction from 'modules/redux/actions/update'
import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import getPathReduxUtil from 'modules/redux/utils/get-path'
import { TRAINING_USERS_DOMAIN } from 'modules/training/modules/training-users/constants'
import getCurrentTrainingUserSelect from 'modules/training/modules/training-users/selectors/get-current'

export default function updateTrainingUserAction (params) {
  return (dispatch, getState) => {
    const {
      key,
      value,
      options
    } = params
    const instance = getCurrentTrainingUserSelect(getState())

    dispatch(
      updateReduxAction({
        type: getActionStrReduxUtil('USER_UPDATE', key),
        payload: {
          path: getPathReduxUtil(instance, TRAINING_USERS_DOMAIN),
          key,
          value,
          options
        }
      })
    )
  }
}
